import _hex2ascii from "hex2ascii";
import _formatRtlText from "../utility/formatRtlText.js";
import _reverseNumbers from "../utility/reverseNumbers.js";
import _reverseAnsiText from "../utility/reverseAnsiText.js";
import _eol from "eol";
import _convertToPlainTextCustom from "../quill/convertToPlainTextCustom.js";
import _cptable from "codepage";
const cptable = _cptable;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
const reverseAnsiText = _reverseAnsiText;
const reverseNumbers = _reverseNumbers;
const formatRtlText = _formatRtlText;
const hex2ascii = _hex2ascii;
export default {
  convertAsciiToHex: function (asciiText) {
    let hexString = "";
    asciiText.split("").forEach(char => {
      hexString += char.charCodeAt(0).toString(16).padStart(2, "0");
    });
    return hexString;
  },
  hexArrayToAscii: function (hexArray) {
    return hexArray.map(hexValue => {
      return this.hexToAscii(hexValue);
    }).join("");
  },
  hexToAscii: function (hexValue) {
    return hex2ascii(hexValue);
  },
  decodeThai(hexArray) {
    // ตารางเทียบรหัส (Mapping Table) จากตัวอย่างที่คุณให้มา
    let result = '';
    let pendingDiacritics = ''; // เปลี่ยนเป็น String เพื่อรองรับกรณีมีหลายตัว หรือตัวรวม

    const bytes = hexArray.filter(h => h !== '7f').map(h => parseInt(h, 16));
    for (let byte of bytes) {
      if (this.thaiDict[byte]) {
        const char = this.thaiDict[byte];

        // If byte is >= 0x80, it is a diacritic (or combined diacritic)
        if (byte >= 0x80) {
          pendingDiacritics = char;
        } else {
          result += char;

          // Flush pending diacritics immediately after the consonant
          if (pendingDiacritics) {
            result += pendingDiacritics;
            pendingDiacritics = '';
          }
        }
      } else {
        if (byte >= 0x20 && byte <= 0x7F) {
          result += String.fromCharCode(byte);
        } else {
          console.log(`[MISSING MAP] 0x${byte.toString(16)}`);
        }
      }
    }
    return result;
  },
  calcTotalFrames: function (mm, ss, ff) {
    let totalFrames = 0;
    //console.log(`-------------------`);
    //console.log(`Calculating total frames using ${mm} ${ss} ${ff}`);
    totalFrames += parseInt(mm, 16) * 256 * 256;
    totalFrames += parseInt(ss, 16) * 256;
    totalFrames += parseInt(ff, 16);

    //console.log("Total: "+totalFrames);
    return totalFrames;
  },
  hexToText: function (lineA, lineB, langA, langB) {
    let text = "";
    text += this.decodeHex(lineA, langB) + "\n";
    text += this.decodeHex(lineB, langB);
    return text;
  },
  getCodeByCmd: function (codes, cmd) {
    let hexValue = Object.keys(codes).find(code => codes[code] === cmd);
    return hexValue;
  },
  encodeHex: function (line, lang) {
    let hexString = "";
    //console.log(lang);
    //console.log(line);
    line.split("").forEach(char => {
      try {
        let charCode = char.charCodeAt(0);
        if (charCode >= 8234 && charCode <= 8239) {
          //console.log(`CharCode (${charCode}) is informational`);
        } else if (lang === 'russian') {
          if (this.getCodeByCmd(this.russianDict, char)) {
            hexString += this.getCodeByCmd(this.russianDict, char);
          } else {
            hexString += cptable[1252].enc[char].toString(16).padStart(2, "0");
          }
        } else if (lang === 'hebrew') {
          if (this.getCodeByCmd(this.hebrewDict, char)) {
            hexString += this.getCodeByCmd(this.hebrewDict, char);
          } else {
            if (cptable[1252].enc[char]) {
              hexString += cptable[1252].enc[char].toString(16).padStart(2, "0");
            } else {
              //console.log("CHAR NOT FOUND IN TABLE: "+ char);
              //console.log("char length: "+char.length);
              //console.log("code value: "+char.charCodeAt(0));
            }
          }
        } else if (lang === 'arabic') {
          if (this.getCodeByCmd(this.arabicDict, char)) {
            hexString += this.getCodeByCmd(this.arabicDict, char);
          } else {
            hexString += cptable[1252].enc[char].toString(16).padStart(2, "0");
          }
        } else if (lang === 'chineseTraditional' || lang === 'chineseSimplified') {
          hexString += cptable[1201].enc[char].toString(16).padStart(2, "0");
        } else {
          if (this.getCodeByCmd(this.specialDict, char)) {
            hexString += this.getCodeByCmd(this.specialDict, char);
          } else {
            hexString += cptable[1252].enc[char].toString(16).padStart(2, "0");
          }
        }
      } catch (err) {
        console.log(err.message);
      }
    });
    //console.log(hexString);
    return hexString;
  },
  decodeTextLine: function (line, lang) {
    let lineText = "";
    if (lang === 'russian') {
      line.forEach(char => {
        if (char === "7f") {
          return;
        }
        if (this.russianDict[char]) {
          lineText += this.russianDict[char];
        } else {
          lineText += this.decodeChar(char, 1252);
        }
      });
    } else if (lang === 'hebrew') {
      line.forEach(char => {
        if (char === "7f") {
          return;
        }
        if (this.hebrewDict[char]) {
          lineText += this.hebrewDict[char];
        } else {
          lineText += this.decodeChar(char, 1252);
        }
      });
    } else if (lang === 'arabic') {
      line.forEach(char => {
        if (char === "7f") {
          return;
        }
        if (this.arabicDict[char]) {
          lineText += this.arabicDict[char];
        } else {
          lineText += this.decodeChar(char, 1252);
        }
      });
    } else if (lang === 'traditional chinese') {
      while (line.length > 0) {
        let char = line.shift();
        if (char === "7f") {
          break;
        }
        if (line.length > 0 && cptable[950].dec[parseInt(char + line[0], 16)]) {
          lineText += cptable[950].dec[parseInt(char + line[0], 16)];
          line.shift();
        } else {
          lineText += this.decodeChar(char, 950);
        }
      }
    } else if (lang === 'simplified chinese') {
      while (line.length > 0) {
        let char = line.shift();
        if (char === "7f") {
          break;
        }
        if (line.length > 0 && cptable[936].dec[parseInt(char + line[0], 16)]) {
          lineText += cptable[936].dec[parseInt(char + line[0], 16)];
          line.shift();
        } else {
          lineText += this.decodeChar(char, 936);
        }
      }
    } else if (lang === 'thai') {
      lineText += this.decodeThai(line);
    } else {
      let skip = false;
      line.forEach((char, index, chars) => {
        if (char === "7f" || skip) {
          skip = false;
          return;
        }
        if (this.specialDict[char + chars[index + 1]]) {
          lineText += this.specialDict[char + chars[index + 1]];
          skip = true;
        } else if (this.specialDict[char]) {
          lineText += this.specialDict[char];
        } else {
          lineText += this.decodeChar(char, 1252);
        }
      });
    }
    return lineText;
  },
  // Decode from Hex
  decodeChar: function (charCode, codePage) {
    try {
      let char = cptable[codePage].dec[parseInt(charCode, 16)];
      return char;
    } catch (e) {
      console.log(e.message);
      return "";
    }
  },
  encodeHeader: function (eventGroup, langA, langB, som, tapeNumber = "unknown", programmeTitle = "unknown", translatedProgrammeTitle = "unknown", translator = "unknown", translatedEpTitle = "unknown", comments = "Created by CCC", fontA, fontB) {
    const lowByte = eventGroup.events.length % 256;
    const highByte = Math.floor(eventGroup.events.length / 256);
    let header = "0000"; // 2 bytes reserved
    header += this.convertAsciiToHex(tapeNumber).padEnd(40, "00"); //Tape Number 2-21 (20 bytes)
    header += "534253000000000000001C1BE20C544C2E44"; // 18 bytes reserved
    header += this.convertAsciiToHex(translatedProgrammeTitle).padEnd(56, "00"); //Translated Program Title
    header += this.convertAsciiToHex(translator).padEnd(56, "00"); //Translated Program Title
    header += "323031383039303400"; // 9 bytes reserved
    header += this.convertAsciiToHex(translatedEpTitle.substring(0, 11)).padEnd(22, "00"); //Translated Episode Title 11 Bytes
    header += "".padStart(36, "00"); // 9 bytes reserved
    header += "A80905030202089000000000" + this.languageCodes[langA] + this.languageCodes[langB];
    header += this.convertAsciiToHex(comments.substring(0, 24)).padEnd(48, "00"); // Comments 24 bytes
    header += "08900100000074"; //control bytes
    header += lowByte.toString(16).padStart(2, "0") + highByte.toString(16).padStart(2, "0");
    header += ("4C544C350000" + this.convertAsciiToHex(fontA)).padEnd(28, "20");
    header += "00000000000000000001410132"; // 13 bytes reserved
    header += lowByte.toString(16).padStart(2, "0") + highByte.toString(16).padStart(2, "0");
    header += lowByte.toString(16).padStart(2, "0") + highByte.toString(16).padStart(2, "0");
    header += "000000020F00"; // 6 bytes reserved
    header += this.convertAsciiToHex(programmeTitle).padEnd(56, "00"); //Original Program Title
    header += this.convertAsciiToHex(fontB).padEnd(18, "20");
    header += "61";
    header += this.convertAsciiToHex(som);
    header += "0000000000000000000000000000000000000000000000000000425449";
    header += "2043504800000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"; // 92 bytes reserved
    header = header.padEnd(776, "00");
    return header;
  },
  /**
   * Converts seconds to frame count
   * @param {number} seconds - Time in seconds (can be fractional)
   * @param {number} frameRate - Frame rate (fps), defaults to 25 (PAL)
   * @returns {number} - Frame count (integer)
   * @throws {Error} - If inputs are invalid
   */
  secondsToFrames: function (seconds, frameRate) {
    // Validate inputs
    if (typeof seconds !== 'number' || seconds < 0) {
      throw new Error(`Invalid seconds: ${seconds}. Must be a non-negative number.`);
    }
    if (typeof frameRate !== 'number' || frameRate <= 0) {
      throw new Error(`Invalid frame rate: ${frameRate}. Must be a positive number.`);
    }

    // Convert to frames and round to nearest integer
    const frames = Math.round(seconds * frameRate);

    // Validate result fits in 24-bit range (0 to 16,777,215)
    if (frames > 0xFFFFFF) {
      throw new Error(`Frame count ${frames} exceeds 24-bit limit (16,777,215). Time too large.`);
    }
    return frames;
  },
  /**
   * Converts frame count to seconds
   * @param {number} frames - Frame count (integer)
   * @param {number} frameRate - Frame rate (fps), defaults to 25 (PAL)
   * @returns {number} - Time in seconds
   * @throws {Error} - If inputs are invalid
   */
  framesToSeconds: function (frames, frameRate) {
    // Validate inputs
    if (!Number.isInteger(frames) || frames < 0) {
      throw new Error(`Invalid frame count: ${frames}. Must be a non-negative integer.`);
    }
    if (typeof frameRate !== 'number' || frameRate <= 0) {
      throw new Error(`Invalid frame rate: ${frameRate}. Must be a positive number.`);
    }

    // Validate frame count fits in 24-bit range
    if (frames > 0xFFFFFF) {
      throw new Error(`Frame count ${frames} exceeds 24-bit limit (16,777,215).`);
    }
    return frames / frameRate;
  },
  /**
   * Encodes frame count as 3-byte big-endian array for Cavena 890
   * @param {number} frames - Frame count (0 to 16,777,215)
   * @returns {Uint8Array} - 3-byte big-endian array [high, mid, low]
   * @throws {Error} - If frame count is invalid
   */
  encodeFrameCount: function (frames) {
    // Validate input
    if (!Number.isInteger(frames) || frames < 0 || frames > 0xFFFFFF) {
      throw new Error(`Invalid frame count: ${frames}. Must be integer between 0 and 16,777,215.`);
    }

    // Extract bytes in big-endian order
    const highByte = frames >> 16 & 0xFF; // Most significant byte
    const midByte = frames >> 8 & 0xFF; // Middle byte
    const lowByte = frames & 0xFF; // Least significant byte

    return new Uint8Array([highByte, midByte, lowByte]);
  },
  /**
   * Decodes 3-byte big-endian array to frame count
   * @param {Uint8Array|Array} bytes - 3-byte array [high, mid, low]
   * @returns {number} - Frame count
   * @throws {Error} - If bytes array is invalid
   */
  decodeFrameCount: function (bytes) {
    // Validate input
    if (!bytes || bytes.length < 3) {
      throw new Error('Invalid bytes array. Must contain at least 3 bytes.');
    }

    // Decode from big-endian
    const highByte = parseInt(bytes[0], 16);
    const midByte = parseInt(bytes[1], 16);
    const lowByte = parseInt(bytes[2], 16);
    const frames = highByte << 16 | midByte << 8 | lowByte;

    // console.log(bytes, "-->", frames);
    return frames;
  },
  /**
   * Converts seconds directly to 3-byte big-endian frame count for Cavena 890
   * @param {number} seconds - Time in seconds
   * @param {number} frameRate - Frame rate (fps), defaults to 25 (PAL)
   * @returns {Uint8Array} - 3-byte big-endian array
   * @throws {Error} - If inputs are invalid
   */
  secondsToFrameBytes: function (seconds, frameRate) {
    const frames = this.secondsToFrames(seconds, frameRate);
    // console.log(frames);
    const highByte = frames >> 16 & 0xFF; // Bits 16-23
    const midByte = frames >> 8 & 0xFF; // Bits 8-15  
    const lowByte = frames & 0xFF;

    // console.log(highByte, midByte, lowByte)

    return highByte.toString(16).padStart(2, "0") + midByte.toString(16).padStart(2, "0") + lowByte.toString(16).padStart(2, "0");
  },
  /**
   * Converts 3-byte big-endian frame count directly to seconds
   * @param {Uint8Array|Array} bytes - 3-byte array [high, mid, low]
   * @param {number} frameRate - Frame rate (fps), defaults to 25 (PAL)
   * @returns {number} - Time in seconds
   * @throws {Error} - If inputs are invalid
   */
  frameBytesToSeconds: function (bytes, frameRate) {
    const frames = decodeFrameCount(bytes);
    return framesToSeconds(frames, frameRate);
  },
  /**
   * Writes frame count to subtitle entry buffer at specified offset
   * @param {Uint8Array} buffer - Subtitle entry buffer (128 bytes)
   * @param {number} offset - Offset where to write (2 for start time, 5 for end time)
   * @param {number} frames - Frame count to write
   * @throws {Error} - If inputs are invalid
   */
  writeFrameCountToBuffer: function (buffer, offset, frames) {
    // Validate inputs
    if (!buffer || buffer.length < offset + 3) {
      throw new Error(`Buffer too small. Need at least ${offset + 3} bytes.`);
    }
    if (offset < 0 || offset > buffer.length - 3) {
      throw new Error(`Invalid offset: ${offset}. Must be between 0 and ${buffer.length - 3}.`);
    }

    // Encode and write
    const frameBytes = this.encodeFrameCount(frames);
    buffer[offset] = frameBytes[0];
    buffer[offset + 1] = frameBytes[1];
    buffer[offset + 2] = frameBytes[2];
  },
  /**
   * Reads frame count from subtitle entry buffer at specified offset
   * @param {Uint8Array} buffer - Subtitle entry buffer
   * @param {number} offset - Offset where to read (2 for start time, 5 for end time)
   * @returns {number} - Frame count
   * @throws {Error} - If inputs are invalid
   */
  readFrameCountFromBuffer: function (buffer, offset) {
    // Validate inputs
    if (!buffer || buffer.length < offset + 3) {
      throw new Error(`Buffer too small. Need at least ${offset + 3} bytes.`);
    }

    // Read and decode
    const frameBytes = new Uint8Array([buffer[offset], buffer[offset + 1], buffer[offset + 2]]);
    return decodeFrameCount(frameBytes);
  },
  /**
   * Formats seconds as human-readable timecode string
   * @param {number} seconds - Time in seconds
   * @param {number} frameRate - Frame rate for frame calculation
   * @returns {string} - Formatted as "HH:MM:SS:FF"
   */
  formatTimecode: function (seconds, frameRate) {
    const totalFrames = this.secondsToFrames(seconds, frameRate);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const secs = Math.floor(seconds % 60);
    const frames = totalFrames % Math.round(frameRate);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}:${frames.toString().padStart(2, '0')}`;
  },
  /**
   * Normalizes a yPos value ("start"/"center"/"end" or a numeric line number)
   * to a 1-indexed line number counted from the top of the display.
   * @param {string|number} yPos - "start", "center", "end", or an integer line number (1 = top row, displayHeight = bottom row)
   * @param {number} displayHeight - Height of the display in lines
   * @returns {number} - Line number from the top (1 to displayHeight)
   */
  normalizeYPosToLine: function (yPos, displayHeight) {
    if (yPos === "start") {
      return 1;
    } else if (yPos === "center") {
      return Math.round((displayHeight + 1) / 2);
    } else if (yPos === "end" || yPos === undefined || yPos === null || yPos === false) {
      return displayHeight;
    } else if (!isNaN(yPos)) {
      return Math.min(Math.max(Math.round(Number(yPos)), 1), displayHeight);
    }
    return displayHeight;
  },
  /**
   * Encodes the vertical position control code written after Line A in a Cavena 890
   * subtitle entry (the 6 bytes between Line A and Line B). The control code has the
   * form `00 00 00 40 <POS> 00`, where <POS> is a value between 0 and 255 that positions
   * the subtitle vertically on screen in reference to the bottom of the screen: the
   * bottommost line has a vertical position of 0, and the topmost line has a vertical
   * position of 255 - (255 / displayHeight). When no override is required (bottom of
   * screen, the default rendering position) the control code is all zeroes.
   * @param {string|number} yPos - "start", "center", "end", or an integer line number (1 = top row, displayHeight = bottom row)
   * @param {number} displayHeight - Height of the display in lines
   * @returns {string} - 12 character (6 byte) hex control code
   */
  encodeYPos: function (yPos, displayHeight) {
    if (!displayHeight || displayHeight <= 0) {
      return "000000000000";
    }
    let lineFromTop = this.normalizeYPosToLine(yPos, displayHeight);
    let lineHeight = 255 / displayHeight;
    let rowFromBottom = displayHeight - lineFromTop;
    let position = Math.min(Math.max(Math.round(rowFromBottom * lineHeight), 0), 255);
    if (position === 0) {
      return "000000000000";
    }
    return "00000040" + position.toString(16).padStart(2, "0") + "00";
  },
  /**
   * Decodes the vertical position control code written after Line A in a Cavena 890
   * subtitle entry back into a yPos value. This is the inverse of `encodeYPos`.
   * @param {Array<string>} controlCodeBytes - The 6 hex byte strings between Line A and Line B (event.seperator)
   * @param {number} displayHeight - Height of the display in lines
   * @returns {string|number} - "start", "end", or an integer line number (1 = top row, displayHeight = bottom row)
   */
  decodeYPos: function (controlCodeBytes, displayHeight) {
    if (!controlCodeBytes || controlCodeBytes.length < 5 || !displayHeight || displayHeight <= 0) {
      return "end";
    }
    let flagByte = parseInt(controlCodeBytes[3], 16) || 0;
    let positionByte = parseInt(controlCodeBytes[4], 16) || 0;
    if (!flagByte && !positionByte) {
      // Default/bottom position, no override present
      return "end";
    }
    let lineHeight = 255 / displayHeight;
    let rowFromBottom = Math.round(positionByte / lineHeight);
    let lineFromTop = Math.min(Math.max(displayHeight - rowFromBottom, 1), displayHeight);
    if (lineFromTop <= 1) {
      return "start";
    } else if (lineFromTop >= displayHeight) {
      return "end";
    }
    return lineFromTop;
  },
  encodeText: function (event, langA, langB, last, yPos, displayHeight) {
    //console.log("-------------");
    //console.log(event.start);
    let res = "";
    let plainText = convertToPlainTextCustom(event.text, "\n", false, "REMOVE_TAG", "em", "REMOVE_TAG");

    // Split the plaintext into an array of text lines
    let textLines = eol.split(plainText);

    // Only take the first two lines (limitation of format)
    textLines = textLines.slice(0, 2);
    if (textLines.length === 1) {
      textLines.unshift("");
    }
    textLines.forEach((line, index, lines) => {
      let encodedTextLine = "";
      let selectedLang = index === 0 ? langA : langB;
      line = line.replace(/<REMOVE_TAG>|<\/REMOVE_TAG>/gmi, "");
      if (selectedLang === "hebrew" || selectedLang === "arabic") {
        line = reverseNumbers(line);
        line = formatRtlText(line);
        line = reverseAnsiText(line);
      }
      let chars = line.split("");
      while (chars.length > 0) {
        let char = chars.shift();
        if (char === "<" && chars.slice(0, 3).join("") === "em>") {
          encodedTextLine += "88";
          chars.splice(0, 3);
        } else if (char === "<" && chars.slice(0, 4).join("") === "/em>") {
          encodedTextLine += "98";
          chars.splice(0, 4);
        } else if (selectedLang === "russian" && this.getCodeByCmd(this.russian, char)) {
          encodedTextLine += this.getCodeByCmd(this.russian, char);
        } else if (selectedLang === "arabic" && this.getCodeByCmd(this.arabicDict, char)) {
          encodedTextLine += this.getCodeByCmd(this.arabicDict, char);
        } else if (selectedLang === "hebrew" && this.getCodeByCmd(this.hebrewDict, char)) {
          encodedTextLine += this.getCodeByCmd(this.hebrewDict, char);
        } else if (selectedLang === "traditional chinese" || selectedLang === "simplified chinese") {
          encodedTextLine += cptable[936].enc[char].toString(16).padStart(4, "0");
        } else if (this.getCodeByCmd(this.specialDict, char)) {
          // console.log("special char: " + char);
          // console.log("code value: " + this.getCodeByCmd(this.specialDict, char));
          encodedTextLine += this.getCodeByCmd(this.specialDict, char);
        } else if (cptable[1252].enc[char]) {
          // console.log("char: " + char);
          // console.log("code value: " + cptable[1252].enc[char]);
          encodedTextLine += cptable[1252].enc[char].toString(16).padStart(2, "0");
        } else {
          console.log("CHAR NOT FOUND IN TABLE: " + char);
          console.log("char length: " + char.length);
          console.log("code value: " + char.charCodeAt(0));
        }
      }

      //Pad and limit to 51 bytes
      encodedTextLine = encodedTextLine.padEnd(102, "7f").slice(0, 102);
      if (index === 0) {
        // We've discovered that the second last byte in the following control codes can be used to position subtitles vertically on screen. The vertical position can be a value between 0 and 255. For example, on an 11 line display, each subtitle has a height of 23.2 pixels (255/11). Vertical position is in reference to the bottom of the screen: therefore, the bottommost subtitle has a vertical position of 0, and the topmost subtitle has a vertical position of 255-23.2=231.8. In order to calculate the position of an Event, we need to know the yPos value, and display height (which is measured in lines).
        encodedTextLine += this.encodeYPos(yPos, displayHeight);
        // 000000000000 = bottom
        // 00000040D900 = top
        // 00000040C400 = Line 1
        // 00000040AF00 = Line 1
      } else if (!last) {
        encodedTextLine += "00000000";
      }
      res += encodedTextLine;
    });

    //If it's only a single line subtitle we need to encode padding for the second line.
    if (textLines.length === 1 && !last) {
      res += "".padEnd(102, "7f") + "00000000";
    }
    return res;
  },
  autoFormat: function (plainText = "") {
    /* cavena890 only supports two line captions */
    let lines = [],
      line = "",
      avgCharsPerLine = plainText.length / 2,
      avgWordsPerLine = plainText.split(" ").length / 2;
    plainText.split(" ").forEach(word => {
      if (lines.length === 1) {
        line += " " + word;
      } else if (line.length + word.length > avgCharsPerLine) {
        lines.push(line.trim());
        line = word;
      } else {
        line += " " + word;
      }
    });
    if (line.length > 0) {
      lines.push(line.trim());
    }
    return lines.join("\n");
  },
  languageCodes: {
    "danish": "07",
    "english": "09",
    "norwegian": "1e",
    "swedish": "28",
    "thai": "4a",
    "greek": "70",
    "russian": "56",
    "arabic": "80",
    "hebrew": "8f",
    "traditional chinese": "90",
    "simplified chinese": "91",
    "romanian": "22",
    "07": "danish",
    "09": "english",
    "56": "russian",
    "80": "arabic",
    "8f": "hebrew",
    "4a": "thai",
    "90": "traditional chinese",
    "91": "simplified chinese",
    "22": "romanian",
    "1e": "norwegian",
    "28": "swedish",
    "70": "greek"
  },
  fontCodes: {
    "danish": "VFONTL",
    "english": "HLV23N",
    "russian": "KYRIL4",
    "arabic": "ARA19N",
    "hebrew": "HEBNOA",
    "traditional chinese": "CCKM44",
    "simplified chinese": "CCKM44",
    "romanian": "HLV23N",
    "greek": "GREEK4",
    "norwegian": "VFONTL",
    "swedish": "VFONTL"
  },
  logoGrams: ['的', '是', '啊', '吧', '好', '吧', '亲', '爱', '的', '早', '上'],
  russianChars: ['я', 'д', 'й', 'л', 'щ', 'ж', 'ц', 'ф', 'ы'],
  arabicDict: {
    "58": "م",
    "41": "ا",
    "4e": "ص",
    "42": "ب",
    "46": "ح",
    "57": "ل",
    "47": "خ",
    "5d": "ي",
    "4a": "ر",
    "2c": "،",
    "59": "ن",
    "5a": "و",
    "43": "ت",
    "1d": "-",
    "49": "ذ",
    "45": "ج",
    "5b": "ه",
    "56": "ك",
    "21": "؟",
    "4c": "س",
    "52": "ع",
    "5c": "ة",
    "5e": "ى",
    "61": "أ",
    "48": "د",
    "4d": "ش",
    "60": "ء",
    "68": "ﻷ",
    "54": "ف",
    "55": "ق",
    "22": "!",
    "67": "ﻻ",
    "66": "ؤ",
    "64": "آ",
    "50": "ط",
    "6a": "ﻵ",
    "4f": "ض",
    "6b": "ﺋ",
    "44": "ث",
    "51": "ظ",
    "53": "غ",
    "4b": "ز",
    "23": "\"",
    "6c": "ـ"
  },
  hebrewDict: {
    "40": "א",
    "41": "ב",
    "42": "ג",
    "43": "ד",
    "44": "ה",
    "45": "ו",
    "46": "ז",
    "47": "ח",
    "49": "י",
    "4c": "ל",
    "4c": `ל`,
    "22": "״",
    "4d": "ם",
    "4e": "מ",
    "4f": "ן",
    "50": "נ",
    "51": "ס",
    "52": "ע",
    "54": "פ",
    "56": "צ",
    "57": "ק",
    "58": "ר",
    "59": "ש",
    "5a": "ת",
    "4b": "כ",
    "4a": "ך",
    "48": "ט",
    "53": "ף",
    "55": "ץ",
    "b1": "a",
    "b2": "b",
    "b3": "c",
    "b4": "d",
    "b5": "e",
    "b6": "f",
    "b7": "g",
    "b8": "h",
    "b9": "i",
    "ba": "j",
    "bb": "k",
    "bc": "l",
    "bd": "m",
    "be": "n",
    "bf": "o",
    "c0": "p",
    "c1": "q",
    "c2": "r",
    "c3": "s",
    "c4": "t",
    "c5": "u",
    "c6": "v",
    "c7": "w",
    "c8": "x",
    "c9": "y",
    "ca": "z",
    "91": "A",
    "db": "B",
    "93": "C",
    "dc": "D",
    "95": "E",
    "96": "F",
    "97": "G",
    "ab": "H",
    "99": "I",
    "9a": "J",
    "9b": "K",
    "9c": "L",
    "dd": "M",
    "de": "N",
    "9f": "O",
    "a0": "P",
    "a1": "Q",
    "a2": "R",
    "a3": "S",
    "a4": "T",
    "a5": "U",
    "a6": "V",
    "a7": "W",
    "a8": "X",
    "a9": "Y",
    "aa": "Z"
  },
  russianDict: {
    "42": "Б",
    "45": "Е",
    "5a": "З",
    "56": "В",
    "49": "И",
    "4e": "Н",
    "58": "Ы",
    "51": "Я",
    "56": "V",
    "53": "С",
    "72": "р",
    "69": "и",
    "71": "я",
    "6e": "н",
    "74": "т",
    "5c": "Э",
    "77": "ю",
    "46": "Ф",
    "5e": "Ч",
    "44": "Д",
    "62": "б",
    "73": "с",
    "75": "у",
    "64": "д",
    "60": "ж",
    "6a": "й",
    "6c": "л",
    "47": "Г",
    "78": "ы",
    "7a": "з",
    "7e": "ч",
    "6d": "м",
    "67": "г",
    "79": "ь",
    "70": "п",
    "76": "в",
    "55": "У",
    "7d": "щ",
    "66": "ф",
    "7c": "э",
    "7b": "ш",
    "50": "П",
    "52": "П",
    "68": "П"
  },
  thaiDict: {
    // --- 1. Consonants (Complete Alphabet A-Z) ---
    // 43 is ค, 44 is ฆ (Skipping obsolete ฃ, ฅ is standard practice)
    0x41: 'ก',
    0x42: 'ข',
    0x43: 'ค',
    0x44: 'ฆ',
    0x45: 'ง',
    0x46: 'จ',
    0x47: 'ฉ',
    0x48: 'ช',
    0x49: 'ซ',
    0x4a: 'ฌ',
    0x4b: 'ญ',
    0x4c: 'ฎ',
    // BEST GUESS: Dor Chada
    0x4d: 'ฏ',
    // BEST GUESS: Tor Patak
    0x4e: 'ฐ',
    0x4f: 'ฑ',
    0x50: 'ฒ',
    0x51: 'ณ',
    0x52: 'ด',
    0x53: 'ต',
    0x54: 'ถ',
    0x55: 'ท',
    0x56: 'ธ',
    0x57: 'น',
    0x58: 'บ',
    0x59: 'ป',
    0x5a: 'ผ',
    0x5b: 'ฝ',
    0x5c: 'พ',
    0x5d: 'ฟ',
    0x5e: 'ภ',
    0x5f: 'ม',
    0x60: 'ย',
    0x61: 'ร',
    0x63: 'ล',
    0x64: 'ว',
    0x65: 'ศ',
    0x66: 'ษ',
    0x67: 'ส',
    0x68: 'ห',
    0x69: 'ฬ',
    0x6a: 'อ',
    0x6b: 'ฮ',
    // --- 2. Inline Vowels & Symbols ---
    0x40: 'ำ',
    // Confirmed Sara Am
    0x6d: 'ะ',
    0x6f: 'า',
    0x70: 'ำ',
    0x76: 'เ',
    0x77: 'แ',
    0x78: 'โ',
    0x79: 'ใ',
    0x7a: 'โ',
    0x7b: 'ๆ',
    // Confirmed Mai Yamok
    0x7c: 'ไ',
    0x7d: 'ๆ',
    // --- 3. Single Diacritics (Stored) ---
    0x81: 'ิ',
    0x82: 'ี',
    0x83: 'ึ',
    0x84: 'ื',
    0x85: 'ั',
    0x86: '์',
    0x87: 'ุ',
    0x8f: 'ู',
    0x88: 'ฺ',
    0x8a: '็',
    0x8b: '่',
    0x8c: '้',
    0x8d: '๊',
    0x8e: '๋',
    // --- 4. Combined Diacritics (Two Marks in One Byte) ---

    // Group 90: Short Lower Vowel (Sara U) + Tones
    0x91: 'ุ่',
    // Sara U + Mai Ek
    0x92: 'ุ้',
    // Sara U + Mai Tho
    0x93: 'ุ๊',
    // Sara U + Mai Tri (PREDICTED)
    0x94: 'ุ๋',
    // Sara U + Mai Chattawa (PREDICTED)

    // Group 98-9A: Long Lower Vowel (Sara Uu) + Tones
    0x99: 'ู่',
    // Sara Uu + Mai Ek
    0x9a: 'ู้',
    // Sara Uu + Mai Tho
    0x9b: 'ู๊',
    // Sara Uu + Mai Tri (PREDICTED)
    0x9c: 'ู๋',
    // Sara Uu + Mai Chattawa (PREDICTED)

    // Group C0: Upper Vowels (I/Ii) + Tones
    0xcb: 'ิ์',
    // Sara I + Karan
    0xcc: 'ี่',
    // Sara Ii + Mai Ek
    0xcd: 'ี้',
    // Sara Ii + Mai Tho
    0xce: 'ี๊',
    // Sara Ii + Mai Tri (PREDICTED)
    0xcf: 'ี๋',
    // Sara Ii + Mai Chattawa (PREDICTED)

    // Group D0: Upper Vowels (Uue) + Tones
    0xd0: 'ึ่',
    // Sara Uue (Short) + Mai Ek 
    0xd1: 'ึ้',
    // Sara Uue (Short) + Mai Tho
    0xd2: 'ึ๊',
    // Sara Uue (Short) + Mai Tri (PREDICTED)
    0xd3: 'ึ๋',
    // Sara Uue (Short) + Mai Chattawa (PREDICTED)

    0xd4: 'ื่',
    // Sara Uue (Long) + Mai Ek 
    0xd5: 'ื้',
    // Sara Uue (Long) + Mai Tho
    0xd6: 'ื๊',
    // Sara Uue (Long) + Mai Tri (PREDICTED)
    0xd7: 'ื๋',
    // Sara Uue (Long) + Mai Chattawa (PREDICTED)

    // --- 5. Thai Numerals (Likely Locations) ---
    0xf0: '๐',
    0xf1: '๑',
    0xf2: '๒',
    0xf3: '๓',
    0xf4: '๔',
    0xf5: '๕',
    0xf6: '๖',
    0xf7: '๗',
    0xf8: '๘',
    0xf9: '๙',
    // --- 6. Punctuation ---
    0x20: ' ',
    0x22: '"',
    0x2e: '.',
    0x2c: ',',
    // Group B0: Symbols (Likely Smart Quotes)
    0xbd: '“',
    0xbe: '”',
    // Group C0: Short I (Sara I) + Tones
    0xc3: 'ิ่',
    // Sara I + Mai Ek
    0xc4: 'ิ้',
    // Sara I + Mai Tho

    // Group C0: Long I (Sara Ii) + Karan
    0xc7: 'ี์',
    // As in "Key" (คีย์)
    // Group E0: Mai Han-Akat (ั) + Tones
    // Assuming sequence: E1=Ek, E2=Tho, E3=Tri, E4=Chattawa
    0xe1: 'ั่',
    // Mai Han-Akat + Mai Ek (e.g. นั่น)
    0xe2: 'ั้',
    // (Prediction) Mai Han-Akat + Mai Tho (e.g. นั้น)
    0xe3: 'ั๊',
    // (Prediction) Mai Han-Akat + Mai Tri (e.g. กั๊ก)
    0xe4: 'ั๋',
    // Mai Han-Akat + Mai Chattawa (e.g. ตั๋ว)
    // --- Updates for Group 90 (Sara U) ---
    0x95: 'ุ์',
    // Sara U + Karan (e.g. พันธุ์) - *Moves here from 0xDD*

    // --- Updates for Group C0 (Sara I/Ii) ---
    0xc8: 'ี์',
    // Sara Ii + Karan (e.g. คีย์)

    // --- Adjustment for Group D0/E0 ---
    // Since 0x95 is now Short U + Karan, 0xDD is likely Long Uu + Karan
    0xdd: 'ู์' // Sara Uu + Karan (Rare, e.g. สคริปต์ might use it erroneously, or foreign words)
  },
  specialDict: {
    "1b": "æ",
    "1c": "ø",
    "1d": "å",
    "1e": "Æ",
    "1f": "Ø",
    "5b": "Æ",
    "5c": "Ø",
    "5d": "Å",
    // "be": "-",
    "e2": "@",
    "e3": '\\',
    "8141": "À",
    "8145": "È",
    "8149": "Ì",
    "814f": "Ò",
    "8155": "Ù",
    "8161": "à",
    "8165": "è",
    "8169": "ì",
    "816f": "ò",
    "8175": "ù",
    "8241": "Á",
    "8243": "Ć",
    "8245": "É",
    "8249": "Í",
    "824c": "Ĺ",
    "824e": "Ń",
    "824f": "Ó",
    "8252": "Ŕ",
    "8253": "Ś",
    "8255": "Ú",
    "8257": "Ẃ",
    "8259": "Ý",
    "825a": "Ź",
    "8261": "á",
    "8263": "ć",
    "8265": "é",
    "8269": "í",
    "826c": "ĺ",
    "826e": "ń",
    "826f": "ó",
    "8272": "ŕ",
    "8273": "ś",
    "8275": "ú",
    "8277": "ẃ",
    "8279": "ý",
    "827a": "ź",
    "8341": "Â",
    "8343": "Ĉ",
    "8345": "Ê",
    "8347": "Ĝ",
    "8348": "Ĥ",
    "8349": "Î",
    "834a": "Ĵ",
    "834f": "Ô",
    "8353": "Ŝ",
    "8355": "Û",
    "8357": "Ŵ",
    "8359": "Ŷ",
    "8361": "â",
    "8363": "ĉ",
    "8365": "ê",
    "8367": "ĝ",
    "8368": "ĥ",
    "8369": "î",
    "836a": "ĵ",
    "836f": "ô",
    "8373": "ŝ",
    "8375": "û",
    "8377": "ŵ",
    "8379": "ŷ",
    "8441": "Ǎ",
    "8443": "Č",
    "8444": "Ď",
    "8445": "Ě",
    "8447": "Ǧ",
    "8449": "Ǐ",
    "844c": "Ľ",
    "844e": "Ň",
    "8452": "Ř",
    "8453": "Š",
    "8454": "Ť",
    "845a": "Ž",
    "8461": "ǎ",
    "8463": "č",
    "8464": "ď",
    "8465": "ě",
    "8467": "ǧ",
    "8469": "ǐ",
    "846c": "ľ",
    "846e": "ň",
    "8472": "ř",
    "8473": "š",
    "8474": "ť",
    "847a": "ž",
    "8541": "Ã",
    "8549": "Ĩ",
    "854e": "Ñ",
    "854f": "Õ",
    "8555": "Ũ",
    "8561": "ã",
    "8569": "ĩ",
    "856e": "ñ",
    "856f": "õ",
    "8575": "ũ",
    "8641": "Ä",
    "8645": "Ë",
    "8649": "Ï",
    "864f": "Ö",
    "8655": "Ü",
    "8659": "Ÿ",
    "8661": "ä",
    "8665": "ë",
    "8669": "ï",
    "866f": "ö",
    "8675": "ü",
    "8679": "ÿ",
    "8c61": "å",
    "8c41": "Å",
    "88": "<em>",
    "98": "</em>",
    "8961": "ă",
    "8941": "Ă",
    "8773": "ş",
    "8753": "Ş",
    "8774": "ţ",
    "8754": "Ţ"
  }
};